function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { createContext, useEffect, useMemo, useRef, useState } from 'react';
import { animated, useSpring } from 'react-spring';
import { clsx, getChildren, guid } from '../../utils';
import BackgroundImage from '../background';
import NivoBox from '../nivo-box';
import NivoSlice from '../nivo-slice';
export var SwiperContext = /*#__PURE__*/createContext({
  activeIndex: 0,
  slideNext: function slideNext() {},
  slidePrev: function slidePrev() {},
  slideTo: function slideTo(index) {},
  slides: [],
  width: 800
});

function Swiper(props) {
  var _props$theme = props.theme,
      theme = _props$theme === void 0 ? "default" : _props$theme,
      _props$effect = props.effect,
      effect = _props$effect === void 0 ? "random" : _props$effect,
      _props$slices = props.slices,
      slices = _props$slices === void 0 ? 15 : _props$slices,
      _props$boxCols = props.boxCols,
      boxCols = _props$boxCols === void 0 ? 8 : _props$boxCols,
      _props$boxRows = props.boxRows,
      boxRows = _props$boxRows === void 0 ? 4 : _props$boxRows,
      _props$animSpeed = props.animSpeed,
      animSpeed = _props$animSpeed === void 0 ? 500 : _props$animSpeed,
      _props$pauseTime = props.pauseTime,
      pauseTime = _props$pauseTime === void 0 ? 3000 : _props$pauseTime,
      _props$startSlide = props.startSlide,
      startSlide = _props$startSlide === void 0 ? 0 : _props$startSlide,
      _props$directionNav = props.directionNav,
      directionNav = _props$directionNav === void 0 ? true : _props$directionNav,
      _props$controlNav = props.controlNav,
      controlNav = _props$controlNav === void 0 ? true : _props$controlNav,
      _props$controlNavThum = props.controlNavThumbs,
      controlNavThumbs = _props$controlNavThum === void 0 ? false : _props$controlNavThum,
      _props$pauseOnHover = props.pauseOnHover,
      pauseOnHover = _props$pauseOnHover === void 0 ? true : _props$pauseOnHover,
      _props$manualAdvance = props.manualAdvance,
      manualAdvance = _props$manualAdvance === void 0 ? false : _props$manualAdvance,
      _props$prevText = props.prevText,
      prevText = _props$prevText === void 0 ? "Prev" : _props$prevText,
      _props$nextText = props.nextText,
      nextText = _props$nextText === void 0 ? "Next" : _props$nextText,
      _props$randomStart = props.randomStart,
      randomStart = _props$randomStart === void 0 ? false : _props$randomStart,
      beforeChange = props.beforeChange,
      afterChange = props.afterChange,
      afterLoad = props.afterLoad,
      lastSlide = props.lastSlide,
      slideshowEnd = props.slideshowEnd,
      children = props.children,
      className = props.className,
      style = props.style; // Set first background

  var _useState = useState({
    src: '',
    alt: '',
    height: 'auto'
  }),
      _useState2 = _slicedToArray(_useState, 2),
      sliderImage = _useState2[0],
      setSliderImage = _useState2[1];

  var variablesRef = useRef({
    currentSlide: 0,
    currentImage: {
      src: '',
      alt: '',
      title: '',
      parentDisplayName: 'Swiper'
    },
    totalSlides: 0,
    running: false,
    paused: false,
    stop: false,
    controlNavEl: false
  });
  var swiperRef = useRef({});

  var _useState3 = useState(800),
      _useState4 = _slicedToArray(_useState3, 2),
      swiperWidth = _useState4[0],
      setSwiperWidth = _useState4[1];

  var timer = useRef(0); // nivo-slice

  var _useState5 = useState([]),
      _useState6 = _slicedToArray(_useState5, 2),
      nivoSlices = _useState6[0],
      setNivoSlices = _useState6[1]; // nivo-boxes


  var _useState7 = useState([]),
      _useState8 = _slicedToArray(_useState7, 2),
      nivoBoxes = _useState8[0],
      setNivoBoxes = _useState8[1]; // caption title


  var _useState9 = useState(''),
      _useState10 = _slicedToArray(_useState9, 2),
      captionTitle = _useState10[0],
      setCaptionTitle = _useState10[1]; // caption spring


  var _useSpring = useSpring(function () {
    return {
      opacity: 0,
      config: {
        duration: animSpeed
      }
    };
  }),
      _useSpring2 = _slicedToArray(_useSpring, 2),
      captionSpring = _useSpring2[0],
      captionAnimate = _useSpring2[1];

  var currentImage = useMemo(function () {
    return _objectSpread({}, variablesRef.current.currentImage);
  }, [variablesRef.current.currentImage.src, variablesRef.current.currentImage.alt]);

  var _getChildren = getChildren(children),
      slides = _getChildren.slides;

  function processCaption() {
    if (variablesRef.current.currentImage.title !== '' && variablesRef.current.currentImage.title !== undefined) {
      var title = variablesRef.current.currentImage.title;

      if (title.substring(0, 1) == '#') {
        var _document$querySelect;

        title = ((_document$querySelect = document.querySelector(title)) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.innerHTML) || '';
      }

      if (captionSpring.opacity.get() === 1) {
        setTimeout(function () {
          setCaptionTitle(title);
        }, animSpeed);
      } else {
        setCaptionTitle(title);
        captionAnimate.stop();
        captionAnimate.start({
          opacity: 1
        });
      }
    } else {
      captionAnimate.stop();
      captionAnimate.start({
        opacity: 0
      });
    }
  }

  function createSlices() {
    var sliceWidth = Math.round(swiperRef.current.offsetWidth / slices);
    var sliceHeight = swiperRef.current.offsetHeight;
    var slicesArr = [];

    for (var i = 0; i < slices; i++) {
      if (i === slices - 1) {
        slicesArr.push({
          uid: guid(),
          config: {},
          delay: 0,
          from: {},
          src: variablesRef.current.currentImage.src,
          to: {},
          imageStyle: {
            position: 'absolute',
            width: swiperRef.current.offsetWidth,
            height: 'auto',
            display: 'block',
            top: 0,
            left: -(sliceWidth + i * sliceWidth - sliceWidth)
          },
          style: {
            left: sliceWidth * i,
            width: swiperRef.current.offsetWidth - sliceWidth * i,
            height: sliceHeight,
            opacity: 0,
            overflow: 'hidden'
          }
        });
      } else {
        slicesArr.push({
          uid: guid(),
          config: {},
          delay: 0,
          from: {},
          src: variablesRef.current.currentImage.src,
          to: {},
          imageStyle: {
            position: 'absolute',
            width: swiperRef.current.offsetWidth,
            height: 'auto',
            display: 'block',
            top: 0,
            left: -(sliceWidth + i * sliceWidth - sliceWidth)
          },
          style: {
            left: sliceWidth * i,
            width: sliceWidth,
            height: sliceHeight,
            opacity: 0,
            overflow: 'hidden'
          }
        });
      }
    }

    return slicesArr;
  }

  function createBoxes() {
    var boxWidth = Math.round(swiperRef.current.offsetWidth / boxCols);
    var boxHeight = swiperRef.current.offsetHeight / boxRows;
    var boxArr = [];

    for (var rows = 0; rows < boxRows; rows++) {
      for (var cols = 0; cols < boxCols; cols++) {
        if (cols === boxCols - 1) {
          boxArr.push({
            uid: guid(),
            config: {},
            delay: 0,
            from: {},
            src: variablesRef.current.currentImage.src,
            to: {},
            imageStyle: {
              position: 'absolute',
              width: swiperRef.current.offsetWidth,
              height: 'auto',
              display: 'block',
              top: -boxHeight * rows,
              left: -(boxWidth * cols)
            },
            style: {
              opacity: 0,
              left: boxWidth * cols,
              top: boxHeight * rows,
              width: swiperRef.current.offsetWidth - boxWidth * cols,
              height: swiperRef.current.offsetHeight
            }
          });
        } else {
          boxArr.push({
            uid: guid(),
            config: {},
            delay: 0,
            from: {},
            src: variablesRef.current.currentImage.src,
            to: {},
            imageStyle: {
              position: 'absolute',
              width: swiperRef.current.offsetWidth,
              height: 'auto',
              display: 'block',
              top: -(boxHeight * rows),
              left: -(boxWidth * cols)
            },
            style: {
              opacity: 0,
              left: boxWidth * cols,
              top: boxHeight * rows,
              width: boxWidth,
              height: swiperRef.current.offsetHeight
            }
          });
        }
      }
    }

    setSliderImage(function (prevState) {
      return _objectSpread(_objectSpread({}, prevState), {}, {
        height: swiperRef.current.offsetHeight
      });
    });
    return boxArr;
  }

  function start() {
    variablesRef.current.paused = true;
    clearInterval(timer.current);
    timer.current = 0;
  }

  function stop() {
    variablesRef.current.paused = false;

    if (!timer.current) {
      timer.current = setInterval(function () {
        return nivoRun(false);
      }, pauseTime);
    }
  } // onMouseEnter


  function onMouseEnter() {
    if (pauseOnHover) {
      start();
    }
  } // onMouseLeave


  function onMouseLeave() {
    if (pauseOnHover) {
      stop();
    }
  } // Event when Animation finishes


  function NivoAnimFinished() {
    setSliderImage({
      height: 'auto',
      src: variablesRef.current.currentImage.src,
      alt: variablesRef.current.currentImage.alt || ''
    });
    variablesRef.current.running = false; // Restart the timer

    if (!timer.current && !variablesRef.current.paused && !manualAdvance) {
      timer.current = setInterval(function () {
        nivoRun(false);
      }, pauseTime);
    } // Trigger the afterChange callback


    afterChange && afterChange();
  } // Private run method


  function nivoRun(nudge) {
    // Trigger the lastSlide callback
    if (variablesRef.current.currentSlide === variablesRef.current.totalSlides - 1) {
      lastSlide && lastSlide();
    } // Stop


    if (variablesRef.current.stop && !nudge) {
      return false;
    } // Trigger the beforeChange callback


    beforeChange && beforeChange(); // Set current background before change

    setSliderImage({
      height: 'auto',
      src: variablesRef.current.currentImage.src,
      alt: variablesRef.current.currentImage.alt || ''
    });
    variablesRef.current.currentSlide++; // Trigger the slideshowEnd callback

    if (variablesRef.current.currentSlide === variablesRef.current.totalSlides) {
      variablesRef.current.currentSlide = 0;
      slideshowEnd && slideshowEnd();
    }

    if (variablesRef.current.currentSlide < 0) {
      variablesRef.current.currentSlide = variablesRef.current.totalSlides - 1;
    } // Set vars.currentImage


    variablesRef.current.currentImage = slides[variablesRef.current.currentSlide].props; // Process caption

    processCaption(); // Remove any slices from last transition

    setNivoSlices([]); // Remove any boxes from last transition

    setNivoBoxes([]);
    var currentEffect = effect;
    var anims = []; // Generate random effect

    if (effect === "random") {
      anims = ['sliceDownRight', 'sliceDownLeft', 'sliceUpRight', 'sliceUpLeft', 'sliceUpDown', 'sliceUpDownLeft', 'fold', 'fade', 'boxRandom', 'boxRain', 'boxRainReverse', 'boxRainGrow', 'boxRainGrowReverse'];
      currentEffect = anims[Math.floor(Math.random() * (anims.length + 1))];

      if (currentEffect === undefined) {
        currentEffect = 'fade';
      }
    } // Run random effect from specified set (eg: effect:'fold,fade')


    if (effect.indexOf(',') !== -1) {
      anims = effect.split(',');
      currentEffect = anims[Math.floor(Math.random() * anims.length)];

      if (currentEffect === undefined) {
        currentEffect = 'fade';
      }
    } // Custom transition as defined by "data-transition" attribute


    if (variablesRef.current.currentImage.transition) {
      currentEffect = variablesRef.current.currentImage.transition;
    } // Run effects


    variablesRef.current.running = true;
    var timeBuff = 0,
        i = 0,
        tempNivoSlices = [],
        firstSlice = {
      config: undefined,
      delay: 0,
      from: undefined,
      src: '',
      to: undefined,
      uid: '',
      style: {}
    },
        totalBoxes = 0,
        boxes = [];

    if (currentEffect === 'sliceDown' || currentEffect === 'sliceDownRight' || currentEffect === 'sliceDownLeft') {
      tempNivoSlices = createSlices();
      timeBuff = 0;
      i = 0;

      if (currentEffect === 'sliceDownLeft') {
        tempNivoSlices.reverse();
      }

      tempNivoSlices = tempNivoSlices.map(function (slice) {
        var sliceTemp = JSON.parse(JSON.stringify(slice));
        sliceTemp.style.top = 0;
        sliceTemp.from = {
          opacity: 0
        };
        sliceTemp.to = {
          opacity: 1
        };
        sliceTemp.config = {
          duration: animSpeed
        };
        sliceTemp.delay = 100 + timeBuff;

        if (i === slices - 1) {
          sliceTemp.onRest = function () {
            NivoAnimFinished();
          };
        }

        timeBuff += 50;
        i++;
        return sliceTemp;
      });
      setNivoSlices(tempNivoSlices);
    } else if (currentEffect === "sliceUp" || currentEffect === "sliceUpRight" || currentEffect === "sliceUpLeft") {
      tempNivoSlices = createSlices();
      timeBuff = 0;
      i = 0;
      var v = 0;

      if (currentEffect === "sliceUpLeft") {
        tempNivoSlices.reverse();
      }

      tempNivoSlices = tempNivoSlices.map(function (item) {
        var sliceTemp = JSON.parse(JSON.stringify(item));

        if (i === 0) {
          sliceTemp.style.top = 0;
          i++;
        } else {
          sliceTemp.style.bottom = 0;
          i = 0;
        }

        sliceTemp.style.bottom = 0;
        sliceTemp.from = {
          opacity: 0
        };
        sliceTemp.to = {
          opacity: 1
        };
        sliceTemp.config = {
          duration: animSpeed
        };
        sliceTemp.delay = 100 + timeBuff;

        if (v === slices - 1) {
          sliceTemp.onRest = function () {
            NivoAnimFinished();
          };
        }

        timeBuff += 50;
        v++;
        return sliceTemp;
      });
      setNivoSlices(tempNivoSlices);
    } else if (currentEffect === "sliceUpDown" || currentEffect === "sliceUpDownRight" || currentEffect === "sliceUpDownLeft") {
      tempNivoSlices = createSlices();
      timeBuff = 0;
      i = 0;
      var _v = 0;

      if (currentEffect === "sliceUpDownLeft") {
        tempNivoSlices.reverse();
      }

      tempNivoSlices = tempNivoSlices.map(function (slice) {
        var sliceTemp = JSON.parse(JSON.stringify(slice));

        if (i === 0) {
          sliceTemp.style.top = 0;
          i++;
        } else {
          sliceTemp.style.bottom = 0;
          i = 0;
        }

        sliceTemp.from = {
          opacity: 0
        };
        sliceTemp.to = {
          opacity: 1
        };
        sliceTemp.config = {
          duration: animSpeed
        };
        sliceTemp.delay = 100 + timeBuff;

        if (_v === slices - 1) {
          sliceTemp.onRest = function () {
            NivoAnimFinished();
          };
        }

        timeBuff += 50;
        _v++;
        return sliceTemp;
      });
      setNivoSlices(tempNivoSlices);
    } else if (currentEffect === "fold") {
      tempNivoSlices = createSlices();
      timeBuff = 0;
      i = 0;
      tempNivoSlices = tempNivoSlices.map(function (slice) {
        var sliceTemp = JSON.parse(JSON.stringify(slice));
        sliceTemp.style.top = 0;
        sliceTemp.from = {
          width: 0,
          opacity: 0
        };
        sliceTemp.to = {
          width: swiperRef.current.offsetWidth,
          opacity: 1
        };
        sliceTemp.config = {
          duration: animSpeed
        };
        sliceTemp.delay = 100 + timeBuff;

        if (i === slices - 1) {
          sliceTemp.onRest = function () {
            NivoAnimFinished();
          };
        }

        timeBuff += 50;
        i++;
        return sliceTemp;
      });
      setNivoSlices(tempNivoSlices);
    } else if (currentEffect === "fade") {
      tempNivoSlices = createSlices();
      firstSlice = tempNivoSlices[0];
      firstSlice.style.width = swiperRef.current.offsetWidth;
      firstSlice.from = {
        opacity: 0
      };
      firstSlice.to = {
        opacity: 1
      };
      firstSlice.config.duration = animSpeed * 2;

      firstSlice.onRest = function () {
        NivoAnimFinished();
      };

      setNivoSlices(tempNivoSlices);
    } else if (currentEffect === "slideInRight") {
      tempNivoSlices = createSlices();
      firstSlice = tempNivoSlices[0];
      firstSlice.style.opacity = 1;
      firstSlice.from = {
        width: 0
      };
      firstSlice.to = {
        width: swiperRef.current.offsetWidth
      };
      firstSlice.config.duration = animSpeed * 2;

      firstSlice.onRest = function () {
        NivoAnimFinished();
      };

      setNivoSlices(tempNivoSlices);
    } else if (currentEffect === "slideInLeft") {
      tempNivoSlices = createSlices();
      firstSlice = tempNivoSlices[0];
      firstSlice.style.opacity = 1;
      firstSlice.style.right = 0;
      firstSlice.style.left = undefined;
      firstSlice.from = {
        width: 0
      };
      firstSlice.to = {
        width: swiperRef.current.offsetWidth
      };
      firstSlice.config.duration = animSpeed * 2;

      firstSlice.onRest = function () {
        setNivoSlices(function (prevState) {
          return prevState.splice(0, 1, _objectSpread(_objectSpread({}, prevState[0]), {}, {
            style: {
              opacity: 1,
              left: 0,
              right: undefined
            }
          }));
        });
        NivoAnimFinished();
      };

      setNivoSlices(tempNivoSlices);
    } else if (currentEffect === "boxRandom") {
      boxes = createBoxes();
      totalBoxes = boxRows * boxCols;
      i = 0;
      timeBuff = 0;
      boxes.forEach(function (boxItem) {
        boxItem.from = {
          opacity: 0
        };
        boxItem.to = {
          opacity: 1
        };
        boxItem.config.duration = animSpeed;
        boxItem.delay = 100 + timeBuff;

        if (i === totalBoxes - 1) {
          boxItem.onRest = function () {
            NivoAnimFinished();
          };
        }

        timeBuff += 20;
        i++;
      });
      setNivoBoxes(boxes);
    } else if (currentEffect === "boxRain" || currentEffect === "boxRainReverse" || currentEffect === "boxRainGrow" || currentEffect === "boxRainGrowReverse") {
      (function () {
        boxes = createBoxes();
        totalBoxes = boxRows * boxCols;
        i = 0;
        timeBuff = 0;
        var rowIndex = 0;
        var colIndex = 0;
        var box2Darr = [];
        box2Darr[rowIndex] = [];

        if (currentEffect === "boxRainReverse" || currentEffect === "boxRainGrowReverse") {
          boxes.reverse();
        }

        boxes.forEach(function (boxItem) {
          box2Darr[rowIndex][colIndex] = boxItem;
          colIndex++;

          if (colIndex === boxCols) {
            rowIndex++;
            colIndex = 0;
            box2Darr[rowIndex] = [];
          }
        }); // Run animation

        for (var cols = 0; cols < boxCols * 2; cols++) {
          var prevCol = cols;

          for (var rows = 0; rows < boxRows; rows++) {
            if (prevCol >= 0 && prevCol < boxCols) {
              /* Due to some weird JS bug with loop vars
              being used in setTimeout, this is wrapped
              with an anonymous function call */
              (function (row, col, time, i, totalBoxes) {
                var box = box2Darr[row][col];
                var w = swiperRef.current.offsetWidth;
                var h = swiperRef.current.offsetHeight;

                if (currentEffect === 'boxRainGrow' || currentEffect === 'boxRainGrowReverse') {
                  box.style.width = 0;
                  box.style.height = 0;
                }

                box.from = {
                  opacity: 0,
                  width: 0,
                  height: 0
                };
                box.to = {
                  opacity: 1,
                  width: w,
                  height: h
                };
                box.config.duration = animSpeed / 1.3;
                box.delay = time + 100;

                if (i === totalBoxes - 1) {
                  box.onRest = function () {
                    NivoAnimFinished();
                  };
                }
              })(rows, prevCol, timeBuff, i, totalBoxes);

              i++;
            }

            prevCol--;
          }

          timeBuff += 100;
        }

        setNivoBoxes(boxes);
      })();
    }
  } // prev click


  function onPrevClick() {
    if (variablesRef.current.running) return false;
    clearInterval(timer.current);
    timer.current = 0;
    variablesRef.current.currentSlide -= 2;
    nivoRun('prev');
  } // nextClick


  function onNextClick() {
    if (variablesRef.current.running) return false;
    clearInterval(timer.current);
    timer.current = 0;
    nivoRun('next');
  } // controlEl Click


  function onControlElClick(e) {
    e.persist();
    var target = e.target;

    if (target.tagName === "IMG") {
      target = target.parentNode;
    }

    if (variablesRef.current.running) return false;
    var index = +target.dataset.rel;
    slideTo(index);
  }

  function slideTo(index) {
    if (variablesRef.current.currentSlide === index || index > variablesRef.current.totalSlides - 1) return false;
    clearInterval(timer.current);
    timer.current = 0;
    variablesRef.current.currentSlide = index - 1;
    nivoRun('control');
  } // onresize


  function onResizeHandler() {
    var swiperWid = swiperRef.current.offsetWidth;
    setSwiperWidth(swiperWid);
    var currentImage = slides[variablesRef.current.currentSlide].props;
    variablesRef.current.currentImage = currentImage;
    setSliderImage(_objectSpread(_objectSpread({}, currentImage), {}, {
      height: 'auto'
    }));
    setNivoSlices([]);
    setNivoBoxes([]);
  }

  useEffect(function () {
    var swiperWid = swiperRef.current.offsetWidth;
    setSwiperWidth(swiperWid);
    variablesRef.current.totalSlides = slides.length;

    if (randomStart) {
      variablesRef.current.currentSlide = Math.floor(Math.random() * variablesRef.current.totalSlides);
    }

    if (startSlide > 0) {
      if (startSlide >= slides.length) variablesRef.current.currentSlide = slides.length - 1;
    }

    var currentImage = slides[variablesRef.current.currentSlide].props;
    variablesRef.current.currentImage = currentImage;
    setSliderImage(currentImage); //Process initial  caption

    processCaption();
    timer.current = setInterval(function () {
      return nivoRun(false);
    }, pauseTime);
    afterLoad && afterLoad();
    return function () {
      return clearInterval(timer.current);
    };
  }, []);
  useEffect(function () {
    window.addEventListener('resize', onResizeHandler);
    return function () {
      return window.removeEventListener('resize', onResizeHandler);
    };
  }, []);
  return /*#__PURE__*/React.createElement(SwiperContext.Provider, {
    value: {
      slideTo: slideTo,
      slideNext: onNextClick,
      slidePrev: onPrevClick,
      activeIndex: variablesRef.current.currentSlide,
      slides: slides,
      width: swiperWidth
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: clsx('slider-wrapper', "theme-".concat(theme), className),
    style: style
  }, /*#__PURE__*/React.createElement("div", {
    className: "nivoSlider",
    ref: swiperRef,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave
  }, children, /*#__PURE__*/React.createElement(BackgroundImage, {
    src: sliderImage.src,
    alt: sliderImage.alt,
    style: {
      width: swiperWidth,
      height: sliderImage.height
    }
  }), /*#__PURE__*/React.createElement(animated.div, {
    className: "nivo-caption",
    style: _objectSpread(_objectSpread({}, captionSpring), {}, {
      display: 'block'
    })
  }, captionTitle), directionNav && /*#__PURE__*/React.createElement("div", {
    className: "nivo-directionNav"
  }, /*#__PURE__*/React.createElement("a", {
    className: "nivo-prevNav",
    onClick: onPrevClick
  }, prevText), /*#__PURE__*/React.createElement("a", {
    className: "nivo-nextNav",
    onClick: onNextClick
  }, nextText)), /*#__PURE__*/React.createElement("div", {
    className: "image-slice-box",
    onClick: currentImage.onClick
  }, nivoSlices.map(function (item) {
    return /*#__PURE__*/React.createElement(NivoSlice, {
      key: item.uid,
      uid: item.uid,
      from: item.from,
      to: item.to,
      config: item.config,
      delay: item.delay,
      src: item.src,
      style: item.style,
      imageStyle: item.imageStyle,
      onRest: item.onRest,
      onChange: item.onChange,
      onDelayEnd: item.onDelayEnd
    });
  }), nivoBoxes.map(function (item) {
    return /*#__PURE__*/React.createElement(NivoBox, {
      key: item.uid,
      uid: item.uid,
      from: item.from,
      to: item.to,
      config: item.config,
      delay: item.delay,
      src: item.src,
      style: item.style,
      imageStyle: item.imageStyle,
      onRest: item.onRest,
      onChange: item.onChange,
      onDelayEnd: item.onDelayEnd
    });
  }))), controlNav && /*#__PURE__*/React.createElement("div", {
    className: clsx('nivo-controlNav', controlNavThumbs && 'nivo-thumbs-enabled')
  }, slides.map(function (item, index) {
    if (controlNavThumbs) {
      return /*#__PURE__*/React.createElement("a", {
        className: clsx('nivo-control', item.props.src === sliderImage.src && 'active'),
        "data-rel": index,
        key: index.toString(),
        "data-src": item.props.src,
        onClick: onControlElClick
      }, /*#__PURE__*/React.createElement("img", {
        src: item.props['thumb'],
        alt: "thumb"
      }));
    }

    return /*#__PURE__*/React.createElement("a", {
      className: clsx('nivo-control', item.props.src === currentImage.src && 'active'),
      "data-rel": index,
      key: index.toString(),
      "data-src": item.props.src,
      onClick: onControlElClick
    }, index + 1);
  }))));
}

Swiper.displayName = "Swiper";
export default Swiper;